module.exports = __webpack_public_path__ + "img/bika_on_bike2.43c4525a.jpg";